import { AxiosInstance } from 'axios';

export type Totals = {
  incident: number;
  incomplete: number;
  highRisk: number;
};

function getFacilityTotals(api: AxiosInstance) {
  return (facilityId: number, yearOfIncidents?: number) => api.get<Totals>(`/totals/facility/${facilityId}`, {
    params: { year_of_incidents: yearOfIncidents }
  });
}

export default getFacilityTotals;
